import {
  createContext,
  PropsWithChildren,
  useContext,
  useMemo,
  useState,
  type ReactElement,
} from 'react';

export interface FavoriteMetadata {
  labels?: string[];
  displayLabel?: string;
  fullLabel?: string;
}

export interface PageMetadata {
  routeKey: string;
  title?: string;
  crumbLabels: string[];
  favoriteMetadata?: FavoriteMetadata;
}

interface PageMetadataContextValue {
  pageMetadata: PageMetadata | null;
  setPageMetadata: (metadata: PageMetadata) => void;
}

const defaultContextValue: PageMetadataContextValue = {
  pageMetadata: null,
  setPageMetadata: () => undefined,
};

const PageMetadataContext =
  createContext<PageMetadataContextValue>(defaultContextValue);

export function PageMetadataProvider({
  children,
}: PropsWithChildren): ReactElement {
  const [pageMetadata, setPageMetadata] = useState<PageMetadata | null>(null);

  const value = useMemo(
    () => ({
      pageMetadata,
      setPageMetadata,
    }),
    [pageMetadata]
  );

  return (
    <PageMetadataContext.Provider value={value}>
      {children}
    </PageMetadataContext.Provider>
  );
}

export function usePageMetadata(): PageMetadataContextValue {
  return useContext(PageMetadataContext);
}
